import React, { useCallback, useContext, useMemo, useRef, useState } from 'react'
import { DomainContext } from '../../context/DomainContext'
import { useTranslation } from 'react-i18next'
import Table from '../../component/tableDrawer/Tables'

import {  DeleteServiceCategory, ExportServiceCategory,  GetserviceCatgory } from '../../api/endpoints'
import { GetPrivileges } from '../../utils'
import { CONTROLLER_NAMES, Paths } from '../../data/Constant'
import ConfirmAlert  from '../../component/confirmAlert'
import { PrivilegeContext } from '../../context/PrivilegesContext'
import CUServiceCategory from './CUServiceCategory'

const ServiceCategories = () => {

    const [data, setData] = useState([])
    const [TotalRows, setTotalRows] = useState(0)
    const [reload, toggleReload] = useState(false)
    const [recordID, setRecordID] = useState(null)

    const ServiceCategoryModal = useRef(null)
    const ServiceCategoryUpdate = useRef(null)
    const ImgModal = useRef(null)

    const { setLoading } = useContext(DomainContext)

    const { authorizedPages } = useContext(PrivilegeContext)


    const { i18n, t } = useTranslation()

    const { canEdit, canAdd, canDelete } = GetPrivileges(authorizedPages, CONTROLLER_NAMES.ServiceCategory)


    const columns = useMemo(() => [
        {
            Header: t("ID"),
            accessor: 'id',
        },
        {
            Header: t("Name"),
            accessor: 'name',
            

        },
        {
            Header: t("nameEn"),
            accessor: 'nameEN',
            

        },
        {
            Header: t("Type"),
            accessor: 'type',
        },
        {
            Header: t("Image"),
            Cell: ({ row: { original } }) =>
            (
                original.image ? <a href={Paths.DashboardServer + original.image} target='_blank' >{t("Click to Open Img")}</a> : ''
            )

        },
        {
            id: 'actions',
            Cell: ({ row: { original } }) =>
            (
                <>
                    {canEdit &&
                        <button className='update' onClick={() => updateHospital(original.id)} >
                            <i className='fas fa-edit'></i>
                        </button>}
                    {canDelete &&
                        <button className='delete' onClick={() => handleDelete(original.id)} >
                            <i className='fas fa-trash'></i>
                        </button>}
                </>
            )
        }
    ], [i18n.language])

    const fetchData = useCallback(({ pageIndex, pageSize, filters }) => {
        setLoading(l => l + 1)
        GetserviceCatgory(filters, pageIndex, pageSize, i18n.language).then(res => {
            setData(res.data)
            setTotalRows(res.data.totalCount)
            setLoading(l => l - 1)
        }).catch(err => {
            setLoading(l => l - 1)
        })

    }, [i18n.language, reload])

    const updateHospital = (id) => {
        setRecordID(id)
        ServiceCategoryUpdate.current.click()
    }

    const handleDelete = (ID) => {


        ConfirmAlert(t('delete ServiceCategory'),
            'Delete This ServiceCategory?', () => {

                setLoading(l => l + 1)
                DeleteServiceCategory(ID).then(res => {
                    setLoading(l => l - 1)
                    toggleReload(e => !e)
                }).catch(err => {
                    setLoading(l => l - 1)
                })
            }, t
        )


    }

    return (
        <>
            {
                canAdd &&
                <>
                    <button className='ActionBtn' onClick={() => ServiceCategoryModal.current.click()}> {t('Add ServiceCategory')}</button>
                    <CUServiceCategory modalID={ServiceCategoryModal} finishOperation={() => ServiceCategoryModal.current.click()} toggleReload={toggleReload} />
                </>
            }

            {canEdit && <>
                <CUServiceCategory modalID={ServiceCategoryUpdate} RecordID={recordID} toggleReload={toggleReload} finishOperation={() => ServiceCategoryUpdate.current.click()} />
            </>}

            <Table
                data={data}
                columns={columns}
                TotalRows={TotalRows}
                fetchData={fetchData}
                exportExcel={ExportServiceCategory}
                hideActions={!canEdit}
            />
        </>
    )
}

export default ServiceCategories